// https://github.com/meduzen/datetime-attribute
import { datetime, duration } from "datetime-attribute";

export default {
    methods: {
        datetime: datetime,
        duration: duration,
    }
};
